<div class="filter-container">
  <p-header>
    <div class="card-header">
      <h3>Account Filters</h3>
    </div>
  </p-header>
  <form [formGroup]="filterForm">
    <div class="filter-actions top-actions">
      <div class="left-actions">
        <p-button
          label="Add"
          severity="info"
          (click)="addFilterRow()">
        </p-button>
        <p-button
          label="Clear All"
          severity="contrast"
          (click)="clearFilters()">
        </p-button>
        <span [pTooltip]="getDisabledToolTip()" tooltipPosition="right">
          @if (filterRows.length !== 0) {
            <p-button
              label="Preview Accounts"
              severity="contrast"
              [disabled]="!hasValidFilters()"
              (click)="previewAccounts()">
            </p-button>
          }
        </span>
      </div>
    </div>
    <div class="filter-header">
      <div class="property-header">Property</div>
      <div class="value-header">Value</div>
      <div class="action-header"></div>
    </div>
    <div formArrayName="filterRows" class="filter-rows">
      <!-- Default message when no filters are present -->
      @if (filterRows.length === 0) {
        <div class="no-filters-message">
          <p>Click 'Add' to add filters</p>
        </div>
      }
      @for (row of filterRows.controls; let i = $index; track i) {
        <div [formGroupName]="i" class="filter-row">
        <div class="property-column">
          <p-select
            [options]="propertyOptions"
            formControlName="property"
            optionLabel="label"
            optionValue="value"
            [style]="{width: '100%'}"
            (onChange)="onPropertyChange(i, $event.value)">
          </p-select>
        </div>
        <div class="value-column">
          <!-- Dynamic input based on selected property -->
          @if (row.value.property === 'Account') {
                <p-multiSelect
                  [options]="accountNameOptions"
                  formControlName="values"
                  placeholder="Select MPOP Accounts"
                  display="chip"
                  [maxSelectedLabels]="1000"
                  [filter]="true"
                  filterBy="label,value"
                  [filterFields]="['label','value']"
                  [resetFilterOnHide]="true"
                  [style]="{ width: '100%' }"
                  optionLabel="label">
                </p-multiSelect>
              } @else if (row.value.property === 'OEM Program') {
                <p-multiSelect
                  [options]="oemProgramOptions"
                  formControlName="values"
                  placeholder="Select OEMs"
                  display="chip"
                  [maxSelectedLabels]="1000"
                  [style]="{ width: '100%' }"
                  optionLabel="label">
                </p-multiSelect>
              } @else if (row.value.property === 'Region Name') {
                <p-multiSelect
                  [options]="regionOptions"
                  formControlName="values"
                  placeholder="Select Regions"
                  display="chip"
                  [maxSelectedLabels]="1000"
                  [style]="{ width: '100%' }"
                  optionLabel="label">
                </p-multiSelect>
              } @else if (row.value.property === 'Account Make') {
                <p-multiSelect
                  [options]="makeOptions"
                  formControlName="values"
                  placeholder="Select Makes"
                  display="chip"
                  [maxSelectedLabels]="1000"
                  [style]="{ width: '100%' }"
                  optionLabel="label">
                </p-multiSelect>
              }
        </div>
          <div class="action-column">
            <p-button
              icon="pi pi-trash"
              severity="danger"
              (click)="removeFilterRow(i)">
            </p-button>
          </div>
        </div>
      }
    </div>
  </form>
</div>
